import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const OrganizationChannelActions = createActionGroup({
  source: 'OrganizationChannel',
  events: {
    billingInformationUpdated: emptyProps(),
    subscriptionUpdated: props<{ payload: { appGuid: string } }>(),
    subscriptionCreated: props<{ payload: { appGuid: string } }>(),
  },
});
